import { getStrapiUrl } from "@src/utils/functions";

const STRAPI_URL = getStrapiUrl();
const STRAPI_TOKEN = import.meta.env.VITE_STRAPI_TOKEN || '';

export interface SimpleFetchOptions {
  collection: string;
  locale?: string;
  populate?: string[];
  filters?: { [key: string]: string };
}

const buildStrapiUrl = (collection: string, locale: string, populate: string[], filters: Record<string, string>): string => {
  let url = `${STRAPI_URL}/api/${collection}?locale=${locale}`;
  
  Object.entries(filters).forEach(([key, value]) => {
    url += `&filters[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`;
  });
  
  populate.forEach(param => {
    url += `&populate=${param}`;
  });
  
  return url;
};

const strapiFetch = async <T>(url: string): Promise<T> => {
  const response = await fetch(url, { 
    method: 'GET', 
    headers: { 
      Authorization: `Bearer ${STRAPI_TOKEN}` 
    }
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  
  return await response.json() as T;
};

export const simpleStrapiFetch = async <T>({
  collection,
  locale = 'en',
  populate = [],
  filters = {}
}: SimpleFetchOptions): Promise<T> => {
  try {
    return await strapiFetch(buildStrapiUrl(collection, locale, populate, filters));
  } catch (error) {
    if (locale !== 'en') {
      try {
        console.warn(`Failed to fetch content in ${locale}, falling back to en`);
        return await strapiFetch(buildStrapiUrl(collection, 'en', populate, filters));
      } catch (fallbackError) {
        console.error(`Error fetching ${collection} content in fallback language:`, fallbackError);
        throw fallbackError;
      }
    }
    
    console.error(`Error fetching ${collection} content:`, error);
    throw error;
  }
};
